import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3v18h18V3zm-6 10h-4v2h4v2H9v-6h4V9H9V7h6v6z"
}), 'LooksTwoSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LooksTwoSharp.js
// module id = 4738
// module chunks = 2